module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"all":"전체"}}')
  delete Component.options._Ctor
}
